var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

import React from 'react';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';

import { Tooltip, PopoverHeader, PopoverBody } from 'reactstrap';

import { MarkdownPanel } from 'sdc-markdown-viewer';

export var HelpIcon = (_dec = inject('helpStore'), _dec(_class = observer(_class = (_class2 = function (_React$Component) {
  _inherits(HelpIcon, _React$Component);

  function HelpIcon() {
    var _temp, _this, _ret;

    _classCallCheck(this, HelpIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initDefineProp(_this, 'showing', _descriptor, _this), _initDefineProp(_this, 'toggle', _descriptor2, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HelpIcon.prototype.render = function render() {
    var _props = this.props,
        helpStore = _props.helpStore,
        topic = _props.topic,
        _props$icon = _props.icon,
        icon = _props$icon === undefined ? 'question' : _props$icon,
        _props$uid = _props.uid,
        uid = _props$uid === undefined ? '' : _props$uid,
        props = _objectWithoutProperties(_props, ['helpStore', 'topic', 'icon', 'uid']);

    var id = 'Tooltip-' + topic.replace(/\./g, '-') + uid;
    return helpStore.hasHelpFor(topic) ? React.createElement(
      React.Fragment,
      null,
      React.createElement(
        'span',
        _extends({ className: 'float-right inline-help-btn', id: id }, props),
        React.createElement('i', { className: 'fa fa-' + icon })
      ),
      React.createElement(
        Tooltip,
        { target: id, isOpen: this.showing, toggle: this.toggle, placement: 'right-start',
          className: 'tooltip-gmcd', x: 12, autohide: false },
        React.createElement(
          PopoverHeader,
          null,
          helpStore.helpTitleFor(topic)
        ),
        React.createElement(
          PopoverBody,
          { className: 'tooltip-gmcd-content' },
          React.createElement(MarkdownPanel, { text: helpStore.helpTextFor(topic), ignoreIndex: true })
        )
      )
    ) : null;
  };

  return HelpIcon;
}(React.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showing', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'toggle', [action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function () {
      _this2.showing = !_this2.showing;
    };
  }
})), _class2)) || _class) || _class);